module.exports = __webpack_public_path__ + "static/easter-banner-bc6d7b04c32708ae08d79b00f29380e3.jpg";